
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(2([235]|13)|[03]88||139|830)|2(110|244|280|333|597|658|855)|5(7(14|36|76)|(22|56|91)8|062|907)|6([78]57|382|418|612)|1(2(33|40|64)|198|424|471|502|582|839|923|960)|8(9(35|8|95)|007|065|452|486)|7((03|10|34)0|187|332|681|911|936)|3((51|58|72)9|044|266|405|480|785|936|994)|9(8(08|15|61|90)|288|431|475|503|724|993))$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
